import React from 'react';
import { Navigate } from 'react-router-dom';
import { paymentUtils } from '../utils/paymentUtils';

const PaymentProtectedRoute = ({ children }) => {
  const isPaymentCompleted = paymentUtils.isPaymentCompleted();

  if (!isPaymentCompleted) {
    // Redirect to payment page if payment is not completed
    return <Navigate to="/care-plan" replace />;
  }

  return children;
};

export default PaymentProtectedRoute; 